export default "__VITE_ASSET__rb465QIF__"